import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { AccountQuotas } from './account-quotas.model';
import { CurrentPlan } from './current-plan.model';
import { PurchaseInfo } from './purchase-info.model';

export const PROVISIONING_SUBSCRIPTION_SCHEMA = Object.freeze({
  CURRENT_PLAN: CurrentPlan,
  ACCOUNT_QUOTAS: AccountQuotas,
  PURCHASE_INFO: PurchaseInfo,
});

const RECORD = generateSchema(PROVISIONING_SUBSCRIPTION_SCHEMA);
const KEYS: any = generateKeys(PROVISIONING_SUBSCRIPTION_SCHEMA);

export class ProvisioningSubscription extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    const selfModel = setInModel(this, [
      {
        key: KEYS.CURRENT_PLAN,
        value: new CurrentPlan(this.currentPlan),
      },
      {
        key: KEYS.ACCOUNT_QUOTAS,
        value: new AccountQuotas(this.accountQuotas),
      },
      {
        key: KEYS.PURCHASE_INFO,
        value: new PurchaseInfo(this.purchaseInfo),
      },
    ]);

    return selfModel as ProvisioningSubscription;
  }

  get currentPlan(): CurrentPlan {
    return this.get(KEYS.CURRENT_PLAN);
  }

  get accountQuotas(): AccountQuotas {
    return this.get(KEYS.ACCOUNT_QUOTAS);
  }

  get purchaseInfo(): PurchaseInfo {
    return this.get(KEYS.PURCHASE_INFO);
  }
}
